export const handleRemoveGroup = (
  groupId: string,
  form: any,
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  uuid: string,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const updatedForm = form.filter(
    (item: any) => item.uuid !== uuid || item.id !== groupId
  );
  setButtonSave(true);
  setForm(updatedForm);
};
